import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { sleep } from '@cf-shared/shared-util';
import { TranslatedString, untranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-textarea',
  templateUrl: 'cs-textarea.html',
  host: { 'class': 'textarea' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTextarea implements AfterViewInit, OnChanges {
  private _value: string = '';

  @ViewChild('textarea') textareaRef: ElementRef<HTMLTextAreaElement>;

  // expose textarea element for external access (compatible with cf-textarea API)
  get input(): ElementRef<HTMLTextAreaElement> { return this.textareaRef; }

  @Input()
  set value(val: string) {
    this._value = val ?? '';
  }
  get value(): string {
    return this._value;
  }

  @Input() placeholder: TranslatedString = untranslatedString('');
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() rows: number = 3;
  @Input() resize: boolean = true;
  @Input('autoadjustheight') autoadjustheight: any = false;
  @Output() valueChange = new EventEmitter<string>();

  constructor(private cdr: ChangeDetectorRef) {}

  isAutoAdjustHeight() {
    return this.autoadjustheight !== undefined && this.autoadjustheight !== null && this.autoadjustheight !== false && this.autoadjustheight !== 'false';
  }

  ngAfterViewInit() {
    if (this.isAutoAdjustHeight()) {
      this.doAutoAdjustHeight();
    }
  }

  ngOnChanges() {
    if (this.isAutoAdjustHeight()) {
      this.doAutoAdjustHeight();
    }
  }

  onInput(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    this._value = target.value;
    this.valueChange.emit(this._value);
    if (this.isAutoAdjustHeight()) {
      this.doAutoAdjustHeight();
    }
  }

  doAutoAdjustHeight() {
    const text = this._value || '';
    this.rows = text.split('\n').length + 1;
    void (async () => {
      await sleep(0);
      if (!this.textareaRef?.nativeElement) return;
      this.textareaRef.nativeElement.style.height = 'auto';
      this.textareaRef.nativeElement.style.height = this.textareaRef.nativeElement.scrollHeight + 'px';
      this.textareaRef.nativeElement.style.overflow = 'hidden';
      this.textareaRef.nativeElement.style.resize = 'none';
      this.cdr.markForCheck();
    })();
  }
}
